import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import Restaurants from '../assets/Restaurants';
import RestaurantItem from './RestaurantItem';
import { useMetaTags } from '../hooks/useMetaTags';

// Import hero image
const burjKhalifa = 'https://cdn.tourcms.com/a/11676/1140/1/large.jpg';

function Home() {
  useMetaTags({
    title: '2 for 1 Restaurant Deals in Dubai | DXB Dates',
    description: 'Discover the best 2 for 1 restaurant deals and dining offers in Dubai. Perfect for date night in the UAE.',
    ogTitle: 'DXB Dates - Best Dining Deals',
    ogImage: 'https://dxbdates.com/og-image.jpg'
  });

  const sliderRef = useRef(null);
  
  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };
  
  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };
  
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Your guide to the best 2 for 1 deals for your DXB Dates</h1>
          <p>We'll help you make use of apps like:<br></br><br></br>- The Entertainer <br></br>- Careem<br></br>- Zomato<br></br><br></br></p>
          <div className="hero-buttons">
            <Link to="/view-restaurants" className="btn btn-primary">All Restaurants</Link>
            <Link to="/map" className="btn btn-outline">See Map</Link>
          </div>
        </div>
        <div className="hero-image">
          <img src={burjKhalifa} alt="Burj Khalifa" />
        </div>
      </section>
      
      {/* Restaurant Section */}
      <section className="restaurant-section">
        <div className="section-title">
          <h2>Most Popular Restaurants</h2>
          <p>Explore the top rated choices by our editors</p>
        </div>
        
        <div className="restaurant-slider">
          <div className="restaurant-items" ref={sliderRef}>
            {Restaurants.map((restaurant, index) => (
              <RestaurantItem 
                key={index}
                index={index}
                image={restaurant.images[0]}
                title={restaurant.name}
                description={restaurant.description}
                price={restaurant.price.priceForTwo}
              />
            ))}
          </div>
          
          <div className="slider-controls">
            <div className="slider-control prev-btn" onClick={scrollLeft}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
              </svg>
            </div>
            <div className="slider-control next-btn" onClick={scrollRight}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
